(function (window, $) {
	'use strict';

	// repair ボタンの表示制御
	// $(window).on("load resize scroll", function () {
	// 	if ($(window).scrollTop() >= 20) {
	// 		$(".ajwn-btn-repair").addClass("is-scroll");
	// 	} else {
	// 		$(".ajwn-btn-repair").removeClass("is-scroll");
	// 	}
	// });

})(window, jQuery);

window.onload = function () {
	// News Ticker
	const newsSwiper = new Swiper(".swiper", {
		direction: "vertical",
		loop: true,
		speed: 1500,
		autoplay: {
			delay: 3000,
		},
	});
};
